import axios from "axios";
import {
  oneincEndpoint,
  portalOne,
  paymentEndpoint,
  maintenanceEndpoint
} from "./apiConfig";
import { getSiteEnvironment } from "./Utils"

const Env = "uat";

const headers = {
  "Content-Type": "application/json",
};

// #region oneinc
export const loadPaymentFromToken = async (Token) => {
  const {method, url} = oneincEndpoint.loadPaymentFromToken
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Token: Token
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse.data
}

export const loadPaymentFromShortcode = async (Token) => {
  const {method, url} = oneincEndpoint.loadPaymentFromShortcode
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Token: Token
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse.data
}

export const getPaymentInfoOneinc = async (PolicyNumber, ZipCode, Env) => {
  const {method, url} = oneincEndpoint.getPaymentInfo
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      PolicyNumber: PolicyNumber,
      Zip: ZipCode,
      Env: Env
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse
}

export const getQuotePaymentInfo = async (QuoteID, ZipCode, Env) => {
  const {method, url} = oneincEndpoint.getQuotePaymentInfo
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      QuoteID: QuoteID,
      Zip: ZipCode,
      Env: Env
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse
}

export const retrieveOneIncSessionID = async (Env) => {
  const {method, url} = oneincEndpoint.retrieveOneIncSessionID
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Env: Env
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse
}

export const enrollAutoPay = async (Policy, PayMethodTokenId, CustomerID, CustomerName, Email, DueDate, AmountPerInstallment, Env, Source) => {
  const {method, url} = oneincEndpoint.enrollAutoPay
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Policy,
      PayMethodTokenId,
      CustomerID,
      CustomerName,
      Email,
      DueDate,
      AmountPerInstallment,
      Env,
      Source
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse.data
}

export const updateAutoPay = async (Policy, PayMethodTokenId, Env) => {
  const {method, url} = oneincEndpoint.updateAutoPay
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Policy,
      PayMethodTokenId,
      Env
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse.data
}

export const cancelAutoPay = async (Policy, Env, Source) => {
  const {method, url} = oneincEndpoint.cancelAutoPay
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Policy,
      Env,
      Source
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse.data
}

export const logDownPayment = async (QuoteNumber, Zip, ConfirmationNumber, AmountPaid, PaymentDate, Env, Device) => {
  const { method, url } = oneincEndpoint.logDownPayment;
  const config = {
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      QuoteNumber,
      Zip,
      ConfirmationNumber,
      AmountPaid,
      PaymentDate,
      Env,
      Device
    },
  };

  var apiResponse;
  try {
    apiResponse = await axios(config);
  } catch (e) {
    console.log(e);
  }
  return apiResponse.data;
};

export const logPayment = async (PolicyNumber, Email, Source, State, Device, Env, PaymentDate, ConfirmationNumber, AmountPaid) => {
  const { method, url } = oneincEndpoint.logPayment;
  const config = {
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      PolicyNumber,
      Email,
      Source,
      State,
      Device,
      Env,
      PaymentDate,
      ConfirmationNumber,
      AmountPaid,
    },
  };

  var apiResponse;
  try {
    apiResponse = await axios(config);
  } catch (e) {
    console.log(e);
  }
  return apiResponse.data;
};

export const logMultiplePayments = async (paymentLogs) => {
  const { method, url } = oneincEndpoint.logMultiplePayments;
  const config = {
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: paymentLogs,
  };

  var apiResponse;
  try {
    apiResponse = await axios(config);
  } catch (e) {
    console.log(e);
  }
  return apiResponse.data;
};

export const logPBT = async (Policy, Zip, Env) => {
  const { method, url } = oneincEndpoint.logPBTStatus;
  const config = {
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      Policy,
      Zip,
      Env,
    },
  };

  var apiResponse;
  try {
    apiResponse = await axios(config);
  } catch (e) {
    console.log(e);
  }
  return apiResponse.data;
};

export const createBindToken = async (Amt, PayDate, CN, Qt, St, Env) => {
  const {method, url} = oneincEndpoint.createBindToken
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    },
    data: {
      Amt,
      PayDate,
      CN,
      Qt,
      St,
      Env
    }
  }
  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse.data
}


export const getUseGenesysWebMessaging = async () => {
  const {method, url} = oneincEndpoint.getUseGenesysWebMessaging
  const config = {
    method,
    url,
    headers: {
      "Content-Type": "application/json"
    }
  }

  var apiResponse;
  try {
    apiResponse = await axios(config)
  }
  catch (e) {
    console.log(e)
  }
  return apiResponse.data
}
// #endregion oneinc

// #region Payment

export const getPaymentInfo = async (policyNumber, systemID, env) => {
  const { method, url, ...props } = paymentEndpoint.getPaymentInfo
  // const Env = await getEnv()

  const config = {
    method,
    url,
    headers,
    data: {
      policyNumber,
      systemID,
      env,
      ...props,
    },
  };
  var apiResponse;
  try {
    apiResponse = await axios(config);

    console.log("GetPaymentInfo", apiResponse);
  } catch (error) {
    console.error("GetPaymentInfo", error);
    return { error };
  }
  return apiResponse.data;
};

export const logPaymentError = async (policyNumber, type, source, errorDescription, errorDetailsObj, env) => {
  const { method, url, ...props } = paymentEndpoint.logPaymentError

  const config = {
    method,
    url,
    headers,
    data: {
      policyNumber,
      type,
      source,
      errorDescription,
      errorDetailsObj,
      env,
      ...props,
    },
  };

  var apiResponse;
  try {
    apiResponse = await axios(config);
  } catch (error) {
    return { error };
  }
  return apiResponse.data;
}

export const getPaymentHistory = async (policyNumber, env) => {
  const { method, url, ...props } = paymentEndpoint.getPaymentHistory

  const config = {
    method,
    url,
    headers,
    data: {
      policyNumber,
      env,
      ...props,
    },
  };

  var apiResponse;
  try {
    apiResponse = await axios(config);
    console.log("GetPaymentHistory", apiResponse);
  } catch (error) {
    console.error("GetPaymentHistory", error);
    return { error };
  }
  return apiResponse.data;
};

export const getAutoPayStatus = async (policyNumber, env) => {
  const { method, url, ...props } = paymentEndpoint.GetAutoPayStatus;

  const config = {
    method,
    url,
    headers,
    data: {
      policyNumber,
      env,
      ...props
    }
  }

  var apiResponse
  try {
    apiResponse = await axios(config)
    // console.log("GetAutoPayStatus", apiResponse)
  } catch (error) {
    // console.error("GetAutoPayStatus", error)
    return { error }
  }
  return apiResponse.data
}

//#endregion

// #region Portal One

export const getCustomerId = async (ExternalCustomerId, CustomerName, env) => {
  const { method, url, ...props } = portalOne.getCustomerId;

  const config = {
    method,
    url: url(env),
    headers,
    data: {
      ExternalCustomerId,
      CustomerName,
      PortalOneAuthenticationKey: portalOne.portalOneAuthKey(env),
      ...props,
    },
  };
  var apiResponse;

  try {
    apiResponse = await axios(config);
    console.log("GetCustomerId", apiResponse);
  } catch (error) {
    console.error("GetCustomerId", error);
    return { ResponseCode: error };
  }
  return apiResponse.data;
};

export const getPaymentMethod = async (CustomerId, env) => {
  const { method, url, ...props } = portalOne.getPaymentMethod;

  const config = {
    method,
    url: url(env),
    headers,
    data: {
      CustomerId: CustomerId,
      PortalOneAuthenticationKey: portalOne.portalOneAuthKey(env),
      ...props,
    },
  };
  var apiResponse;

  // console.log(config);
  try {
    apiResponse = await axios(config);
    // console.log("GetPaymentMethod", apiResponse);
  } catch (error) {
    console.error("GetPaymentMethod", error);
    return { ResponseCode: error };
  }
  return apiResponse.data;
};

export const checkAutoPay = async (TokenId, env) => {
  const { method, url, ...props } = portalOne.checkAutoPay;

  const config = {
    method,
    url: url(env),
    headers,
    data: {
      AuthenticationKey: portalOne.authKey(env),
      TokenId,
      ...props,
    },
  };
  var apiResponse;

  try {
    apiResponse = await axios(config);
    console.log("CheckAutoPay", apiResponse);
  } catch (error) {
    console.error("CheckAutoPay", error);
    return { ResponseCode: error };
  }
  return apiResponse.data;
};

export const getActiveInstallmentPlan = async (PolicyRefNumber, env) => {
  const { method, url, ...props } = portalOne.getActiveInstallmentPlan;

  const config = {
    method,
    url: url(env),
    headers,
    data: {
      AuthenticationKey: portalOne.authKey(env),
      PolicyRefNumber,
      ...props,
    },
  };
  var apiResponse;

  try {
    apiResponse = await axios(config);
    // console.log("GetActiveInstallmentPlan", apiResponse);
  } catch (error) {
    console.error("GetActiveInstallmentPlan", error);
    return { ResponseCode: error };
  }
  return apiResponse.data;
};

export const GetEnvironmentSettings = async () => {
  if (typeof window !== 'undefined') {
    if(window.location.hostname == "payments.cure.com" || window.location.hostname == "localhost" || process.env.NODE_ENV == 'development'){
      return 'prod'
    }
  }
  const { method, url } = paymentEndpoint.GetEnvironmentSettings;
  var data = {
    host:window.location.hostname
  }
  
  const config = {
    method,
    url,
    headers,
    data,
  };
  var apiResponse;

  try {
    apiResponse = await axios(config);
    console.log("GetEnvironmentSettings", apiResponse);
  } catch (error) {
    console.error("GetEnvironmentSettings", error);
    return { ResponseCode: error };
  }
  return apiResponse.data.GWDbEnv;
};
// #endregion Portal One

//#region Maintenance
export const getWebsiteMaintenanceMessage = async content => {
  const { method, url } = maintenanceEndpoint.getWebsiteMessage;

  const config = {
    method,
    url,
    headers,
    data: { Environment: getSiteEnvironment() }
  }

  let apiResponse
  try {
    apiResponse = await axios(config)
  } catch (error) {
    console.log(error)
  }
  return apiResponse
}

export const getWebsiteMaintenanceStatus = async content => {
  const { method, url } = maintenanceEndpoint.getWebsiteStatus;
  
  const config = {
    method,
    url,
    headers,
    data: { Environment: getSiteEnvironment() }
  }

  let apiResponse
  try {
    apiResponse = await axios(config)
  } catch (error) {
    console.log(error)
  }
  return apiResponse
};
//#endregion Maintenance
